<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div class="flex items-center">
      <div class="dropdown-heading-icon flex items-center justify-center">
        <mat-icon svgIcon="mat:person"></mat-icon>
      </div>
      <div class="dropdown-heading" title="{{authService.currentUserValue.email}}">{{authService.currentUserValue.name}}</div>
    </div>

    <button mat-icon-button matTooltip="Zobrazit 2FA QR kód" matTooltipPosition="before" type="button" (click)="open2FAQRCode()">
      <mat-icon svgIcon="mat:key"></mat-icon>
    </button>
  </div>

  <div class="dropdown-content">
    @for (item of items; track trackById($index, item)) {
      <a (click)="close()"
        [routerLink]="item.route"
        class="notification flex items-center"
        matRipple>
        <mat-icon [svgIcon]="item.icon"
          [ngClass]="item.colorClass"
        class="notification-icon flex-none"></mat-icon>
        <div class="flex-auto">
          <div class="notification-label">{{ item.label }}</div>
          <div class="notification-description">{{ item.description }}</div>
        </div>
        <mat-icon class="notification-chevron flex-none" svgIcon="mat:chevron_right"></mat-icon>
      </a>
    }
  </div>

  <div class="dropdown-footer flex items-center justify-between">
    <a (click)="close()" [routerLink]="['/login']" color="secondary" mat-button>Odhlásit</a>
  </div>
</div>
